import { render } from "./DrinkPlusLogo.vue?vue&type=template&id=9b0dfee2"
import script from "./DrinkPlusLogo.vue?vue&type=script&lang=js"
export * from "./DrinkPlusLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__